(function preAuthLoader() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  const codeVerifier = sessionStorage.getItem("code_verifier");

  if (code && codeVerifier && typeof bcl?.u?.addBhgLoading === "function") {
    bcl.u.addBhgLoading();
  }
})();

if (document.readyState !== "loading") {
  bcl.u.loadAsyncData();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    bcl.u.loadAsyncData();
  });
}
